/**
 * Some colors called after "grey" color from ".\themes\v9\themeDuplicates.ts", for example grey[70] (the closest color could be replaced with).
 * https://react.fluentui.dev/?path=/docs/theme-theme-designer--docs
 */
export const pcpGrayPalette = {
    callPageBackground: "#444A5A", //it's used as background for call page. Color from figma (looks like blue hue, but has small color-saturation).
    foreground: "#75839D",  //color from figma (looks like blue hue, but has small color-saturation).
    grey64: "#96A0B4",   //color from figma (looks like blue hue, but has small color-saturation).
    grey70: '#B3B6B9',
    grey82: '#cdcfd1',  //color from figma (looks like blue hue, but has small color-saturation).
    grey94: '#f0f2f4',
    grey100: '#FFFFFF',
}